import React from "react";

export function formatAssetKind(assetKind) {
  return assetKind.split("/").pop()?.split(".")[0].replace("-", " ");
}

export default function AssetKind({ assetKind }) {
  return formatAssetKind(assetKind);
}
